import React, { useState } from 'react';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import { Container, Row, Col, Image } from "react-bootstrap"



const Equipo = () => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useIntersectionObserver(setIsVisible);

  const equipos = [
    {
      equipo: "Coordinación",
      miembros: [
        {
          name: "Sheyla Gabulle",
          job: "Chief People Officer",
          image: "/images/personas/sheyla_gabulle.jpeg",
        },
        {
          name: 'Antonio Antezana',
          job: 'Talent Acquisition Lead',
          image: '/images/personas/antonio_antezana.jpeg',
        },
        {
          name: 'Mariagracia Gonzalez Said',
          job: 'Talent Acquisition Assistant',
          image: '/images/personas/mariagracia_gonzalez_said.jpeg',
        }
      ]
    },
    {
      equipo: "Contenido Comunicaciones",
      miembros: [
        {
          name: "Kiara Miranda",
          job: "Analista de Comunicación Interna y Cultura",
          image: "/images/personas/kiara_miranda.jpeg",
        }
      ]
    },
    {
      equipo: "Desarrollo Web",
      miembros: [
        {
          name: "Jorge Escribens",
          job: "Líder Técnico",
          image: "/images/personas/jorge_escribens.jpeg",
        },
        {
          name: "Carla Sanchez",
          job: "Programadora Front-end",
          image: "/images/personas/carla_sanchez.jpeg",
        }
      ]
    }
  ]

  return (
    <>
    <div className='headermodule'>
        <Image src="/images/banner_vml.jpg" fluid />
    </div>

    <Container id="equipo" ref={ref} className={`opacitycontainer container -mt-3 ${isVisible ? 'fade-in' : ''}`}>
      <h1>Academy Team</h1>
      {equipos.map((equipo, equipoIndex) => (
        <div key={equipoIndex}>
          <h3 className='mb-4' style={{ fontSize: "1.5rem", fontWeight: "500", color: "#232323" }}>{equipo.equipo}</h3>
          <Row className='mb-4'>
            {equipo.miembros.map((miembro, miembroIndex) => (
              <Col lg={3} md={6} sm={12} key={`${equipoIndex}-${miembroIndex}`} className="mb-4">
                <div style={{ display: "flex", flexDirection: "row", height: "100%" }}>
                  <Image
                    src={miembro.image || "/placeholder.svg"}
                    alt={miembro.name}
                    roundedCircle
                    style={{
                      width: "100px",
                      objectFit: "cover",
                      objectPosition: "center",
                      aspectRatio: "1/1",
                      marginRight: "1rem",
                    }}
                  />
                  <div style={{ display: "flex", flexDirection: "column", flex: 1, justifyContent: "center" }}>
                    <h5 style={{ color: "#ff01a7" }}>{miembro.name}</h5>
                    <h6 className="text-muted">{miembro.job}</h6>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      ))}
    </Container>
    </>
  )
}

export default Equipo